@if (isLocationSetTypeParent) {
  <mat-form-field class="menu-filter">
    <mat-label>Select Location Set Type Parent</mat-label>
    <input
      aria-label="Location Set Type Parent"
      [attr.data-testid]="'location_set_type_select'"
      [formControl]="locationSetCtrl"
      [matAutocomplete]="parentAuto"
      matInput
      [placeholder]="placeholderTextParent"
      (paste)="locationSetPasted()"
      (keydown)="locationSetTyped()"
      />
    <mat-autocomplete
      #parentAuto="matAutocomplete"
      [displayWith]="autoCompleteDisplay"
      class="offset"
      >
      @for (parentLocationSet of parentLocationSets; track parentLocationSet) {
        <mat-option
          [attr.data-testid]="parentLocationSet.name + '_option'"
          [value]="parentLocationSet"
          >
          {{ parentLocationSet.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
}
@if (locationSets && !isLocationSetTypeParent) {
  <mat-form-field class="menu-filter">
    <mat-label>Select Location Set</mat-label>
    <input
      aria-label="Location Set"
      [attr.data-testid]="placeholderText + '_select'"
      [formControl]="locationSetCtrl"
      [matAutocomplete]="auto"
      matInput
      [placeholder]="placeholderText"
      (paste)="locationSetPasted()"
      (keydown)="locationSetTyped()"
      />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="autoCompleteDisplay"
      class="offset"
      >
      @for (locationSet of locationSets; track locationSet) {
        <mat-option
          [attr.data-testid]="locationSet.name + '_option'"
          [value]="locationSet"
          >
          <span>{{ locationSet.tag }} - {{ locationSet.name }}</span>
        </mat-option>
      }
    </mat-autocomplete>
    @if (locationSetCtrl.value) {
      <button
        [attr.data-testid]="'location_set_close_button'"
        matSuffix mat-icon-button aria-label="Clear"
        (click)="resetSelectedLocationSet()"
        >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
}
@if (!hideVenueSelector && !(selectedLocationSetType.tag !== 'LOCATION') && selectedFeatureScope === 'Viewer') {
  <mat-form-field
    class="menu-filter">
    <mat-label>Select Venue (Optional)</mat-label>
    <input
      aria-label="Venue"
      [attr.data-testid]="venuePlaceHolderText + '_select'"
      [formControl]="venueCtrl"
      [matAutocomplete]="venueAuto"
      matInput
      [placeholder]="venuePlaceHolderText"
      />
    <mat-autocomplete
      #venueAuto="matAutocomplete"
      [displayWith]="autoCompleteDisplayVenue"
      class="offset"
      >
      @for (venue of venues; track venue) {
        <mat-option
          [attr.data-testid]="venue.venueId+ '_option'"
          [value]="venue"
          >
          @if (venue.name) {
            <span>{{ venue.name }}</span>
          }
          @if (!venue.name) {
            <span>{{ venue.venueId }}</span>
          }
        </mat-option>
      }
    </mat-autocomplete>
    @if (venueCtrl.value) {
      <button
        [attr.data-testid]="'venue_close_button'"
        matSuffix mat-icon-button aria-label="Clear"
        (click)="resetSelectedVenueId()"
        >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
}
